import React from 'react';
// We want to iterate it to put all values in ALL_EVENTS below
export var PreviewsTimingEvents;
(function (PreviewsTimingEvents) {
    PreviewsTimingEvents["START_SESSION"] = "previews_start_session";
    PreviewsTimingEvents["CONTAINER_CODE_START"] = "previews_container_code_start";
    PreviewsTimingEvents["CONTAINER_MOUNT"] = "previews_container_mount";
    PreviewsTimingEvents["COLLECTION_VIEWER_CODE_START"] = "previews_collection_viewer_code_start";
    PreviewsTimingEvents["COLLECTION_VIEWER_MOUNT"] = "previews_collection_viewer_mount";
    PreviewsTimingEvents["SDK_FILE_VIEWER_CODE_START"] = "previews_sdk_file_viewer_code_start";
    PreviewsTimingEvents["FVSDK_GET_RIVIERA_DATA_START_START"] = "previews_get_riviera_data_start";
    PreviewsTimingEvents["FVSDK_GET_RIVIERA_DATA"] = "previews_fvsdk_get_riviera_metadata";
    PreviewsTimingEvents["FVSDK_APP_MOUNT"] = "previews_fvsdk_app_mount";
    PreviewsTimingEvents["FVSDK_RIGHT_RAIL_MOUNT"] = "previews_fvsdk_right_rail_mount";
    PreviewsTimingEvents["FVSDK_TITLE_BAR_MOUNT"] = "previews_fvsdk_title_bar_mount";
    PreviewsTimingEvents["PREVIEW_COMPONENT_MOUNT"] = "preview_component_mount";
    PreviewsTimingEvents["PREVIEW_RENDERER_MOUNT"] = "preview_renderer_mount";
    PreviewsTimingEvents["ASYNC_IMAGE_CONTAINER_MOUNT"] = "previews_async_img_container_mount";
    PreviewsTimingEvents["FVSDK_IMAGE_CONTAINER_START"] = "previews_fvsdk_img_container_start";
    PreviewsTimingEvents["FVSDK_IMAGE_CONTAINER_MOUNT"] = "previews_fvsdk_img_container_mount";
    PreviewsTimingEvents["FVSDK_IMAGE_ON_LOAD"] = "previews_fvsdk_img_onload";
    PreviewsTimingEvents["FVSDK_FULL_IMAGE_ON_LOAD"] = "previews_fvsdk_full_img_onload";
    PreviewsTimingEvents["ASYNC_DOC_CONTAINER_MOUNT"] = "previews_async_doc_container_mount";
    PreviewsTimingEvents["FVSDK_DOC_CONTAINER_START"] = "previews_fvsdk_doc_container_start";
    PreviewsTimingEvents["FVSDK_DOC_CONTAINER_MOUNT"] = "previews_fvsdk_doc_container_mount";
    PreviewsTimingEvents["FVSDK_FIRST_DOC_PAGE_ON_LOAD"] = "previews_fvsdk_first_doc_page_onload";
    PreviewsTimingEvents["FVSDK_DOC_METADATA_LOAD"] = "previews_fvsdk_doc_metadata_load";
    PreviewsTimingEvents["ASYNC_VIDEO_CONTAINER_MOUNT"] = "previews_async_video_container_mount";
    PreviewsTimingEvents["FVSDK_VIDEO_CONTAINER_START"] = "previews_fvsdk_video_container_start";
    PreviewsTimingEvents["FVSDK_VIDEO_CONTAINER_MOUNT"] = "previews_fvsdk_video_container_mount";
    PreviewsTimingEvents["FVSDK_VIDEO_MASTER_PLAYLIST_LOADED"] = "previews_fvsdk_video_master_playlist_loaded";
    PreviewsTimingEvents["FVSDK_VIDEO_PLAYER_READY"] = "previews_fvsdk_video_player_ready";
    PreviewsTimingEvents["FVSDK_MARK_FCP"] = "previews_fvsdk_mark_fcp";
    PreviewsTimingEvents["FVSDK_MARK_LCP"] = "previews_fvsdk_mark_lcp";
    PreviewsTimingEvents["FVSDK_MARK_TTVC"] = "previews_fvsdk_mark_ttvc";
})(PreviewsTimingEvents || (PreviewsTimingEvents = {}));
const ALL_EVENTS = Object.values(PreviewsTimingEvents);
/**
 * Utility class to help with marking various previous performance events. This is used to get timeline of various
 * events and we can get an overview of where the time is spent from start of our session until TTI
 */
class TimelineLogger {
    constructor(startEvent) {
        this.getPerfEntry = (eventName) => {
            var _a;
            const entry = (_a = performance.getEntriesByName) === null || _a === void 0 ? void 0 : _a.call(performance, eventName, 'mark');
            if (entry) {
                return entry[0];
            }
            return null;
        };
        /**
         * Gets the PerformanceEntry of the start_session for this preview object
         * For our purpose, Session is started when start executing the container code (onload) or when you click a file (TODO)
         */
        this.getStartEntry = () => {
            var _a;
            const entry = (_a = performance.getEntriesByName) === null || _a === void 0 ? void 0 : _a.call(performance, this.startEvent, 'mark');
            if (entry) {
                return entry[0];
            }
            return null;
        };
        /**
         * Ends the current session. Cleans up the marked performance entries
         */
        this.endCurrentSession = () => {
            ALL_EVENTS.forEach((eventName) => {
                var _a;
                (_a = performance.clearMarks) === null || _a === void 0 ? void 0 : _a.call(performance, eventName);
            });
        };
        /**
         * Marks the start point of where we want to measure the timing
         */
        this.startLoggingSession = () => {
            var _a;
            this.endCurrentSession();
            (_a = performance.mark) === null || _a === void 0 ? void 0 : _a.call(performance, this.startEvent);
        };
        /**
         * Wrapper around performance.mark to mark the previews event. Only marks the event if we haven't already marked
         * and if we have started the session
         */
        this.mark = (eventName, customTime) => {
            var _a;
            if (!this.getPerfEntry(eventName) && this.getStartEntry()) {
                (_a = performance.mark) === null || _a === void 0 ? void 0 : _a.call(performance, eventName, { startTime: customTime });
            }
        };
        /**
         * Gets the time of marked events from start_session
         *
         */
        this.getEventTimeline = () => {
            const timingEvents = {};
            const startEntry = this.getStartEntry();
            if (!startEntry) {
                return timingEvents;
            }
            ALL_EVENTS.forEach((event) => {
                if (event !== this.startEvent) {
                    const perfEntry = this.getPerfEntry(event);
                    if (perfEntry && perfEntry.startTime >= startEntry.startTime) {
                        timingEvents[event] = perfEntry.startTime - startEntry.startTime;
                    }
                }
            });
            return timingEvents;
        };
        /**
         * Gets all of the events including the start_session with its raw recorded startTime
         *
         */
        this.getEventTimelineWithStartTime = () => {
            const timingEvents = {};
            const startEntry = this.getStartEntry();
            if (!startEntry) {
                return timingEvents;
            }
            ALL_EVENTS.forEach((event) => {
                const perfEntry = this.getPerfEntry(event);
                if (perfEntry && perfEntry.startTime >= startEntry.startTime) {
                    timingEvents[event] = perfEntry.startTime;
                }
            });
            return timingEvents;
        };
        this.getTimeSinceSessionStart = () => {
            var _a;
            const startEntry = this.getStartEntry();
            return startEntry ? ((_a = performance.now) === null || _a === void 0 ? void 0 : _a.call(performance)) - startEntry.startTime : null;
        };
        this.startEvent = startEvent;
    }
}
export const PreviewsEventLogger = new TimelineLogger(PreviewsTimingEvents.START_SESSION);
/**
 * Utility hook to start preview logging session. This will only start a session once per component mount
 */
export const usePreviewTimingSession = () => {
    const hasStartedRef = React.useRef(false);
    if (!hasStartedRef.current) {
        PreviewsEventLogger.startLoggingSession();
        hasStartedRef.current = true;
    }
};
export const useMarkTimingEventOnMount = (event) => {
    React.useEffect(() => {
        PreviewsEventLogger.mark(event);
    }, [event]);
};
//# sourceMappingURL=performance.preenvesnextjs.map
